import {connect} from 'react-redux';
import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import InfoList from "../../shared/infolist";
import {Button, Icon} from "antd";
import {withRouter} from 'react-router-dom';
import * as APP_CONFIG from "../../../constants/config";
const {benchmarkApi} = APP_CONFIG;


class InverterList extends Component {

    static propTypes = {
        history: PropTypes.object.isRequired,
        locationId: PropTypes.number,
        loggerId: PropTypes.number,
        showTitle: PropTypes.bool
    };

    static defaultProps = {
        showTitle: true,
        locationId: 0,
        loggerId: 0
    };

    loadPage = (id) => {
        console.log("load inverter", id)
        this.props.history.push(`/omvormers/${id}`)
    }

    render() {
        return (
            <Fragment>
                {
                    this.props.showTitle ?
                        <h1>Omvormers</h1> : ''
                }
                <InfoList dataSourceFunc={async () => {
                    const request = await fetch(`${benchmarkApi}inverters`);
                    let data = await request.json();
                    if(this.props.locationId > 0)
                        data = data.filter((row) => row.location_id === this.props.locationId);
                    if(this.props.loggerId > 0)
                        data = data.filter((row) => row.logger_id === this.props.loggerId);
                    return data;
                }} columns={[
                    {
                        title: '#',
                        dataIndex: 'id',
                    }, {
                        title: 'Locatie',
                        dataIndex: 'name',
                        render: (text, row, index) => <Fragment>[{row.location_id}] {row.name}</Fragment>,
                    }, {
                        title: 'Type',
                        dataIndex: 'type',
                    }, {
                        title: 'Adres',
                        dataIndex: 'address',
                    }, {
                        title: 'Actief',
                        dataIndex: 'active',
                        render: (text, row, index) => <Icon type={text ? "check-circle" : "close-circle"} size="large" style={{color: text ? 'green': 'red'}} />,
                    }, {
                        title: 'Acties',
                        dataIndex: 'x',
                        render: (text, row, index) => <Button onClick={() => this.loadPage(row.id)}>Bekijken</Button>,
                    }
                ]} rowKey="id" />
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {return {}}

export default connect(mapStateToProps)(withRouter(InverterList));



// WEBPACK FOOTER //
// ./src/components/baseinfo/inverters/list.js